import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { connect } from 'react-redux';

import { setUserSetting } from '../../actions/Auth';

import { isLoggedIn } from '../../api/Auth';
import { APIupdateUserSettings } from '../../api/User';

import { addFlashMessage } from '../../helpers/FlashMessages';
import { getDefaultSortParams } from '../../helpers/Sort';

const SaveSort = ({
  profile,
  orderby,
  order,
  goalSortSettingValue,
  updateUserSetting,
  scope,
  collection,
}) => {
  const intl = useIntl();

  const [defaultSort, setDefaultSort] = useState(getDefaultSortParams(scope));

  const showSaveDefault = isLoggedIn() && profile
    && goalSortSettingValue && !collection
    && (defaultSort.orderby !== orderby || defaultSort.order !== order);

  const handleUpdate = async () => {
    const settingToUpdate = {
      default_sort: goalSortSettingValue?.key,
    };

    await APIupdateUserSettings(profile.uuid, settingToUpdate);
    updateUserSetting(settingToUpdate);
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({
        defaultMessage: 'Updated default sort',
      }),
    });
    setDefaultSort({ orderby, order });
  };

  if (!showSaveDefault) return null;

  return (
    <>
      <Button
        size="sm"
        color="link"
        id="SaveDefaultSort"
        onClick={handleUpdate}
      >
        {intl.formatMessage({ defaultMessage: 'Save' })}
      </Button>
      <UncontrolledTooltip target="SaveDefaultSort">
        {intl.formatMessage({ defaultMessage: 'Save default sort' })}
      </UncontrolledTooltip>
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

const mapDispatchToProps = dispatch => ({
  updateUserSetting: (setting) => {
    dispatch(setUserSetting(setting));
  },
});

SaveSort.propTypes = {
  profile: PropTypes.object,
  orderby: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  scope: PropTypes.string.isRequired,
  updateUserSetting: PropTypes.func.isRequired,
  goalSortSettingValue: PropTypes.object,
  collection: PropTypes.object,
};

SaveSort.defaultProps = {
  profile: null,
  goalSortSettingValue: null,
  collection: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(SaveSort);
